// @tg-seq: 11091
/**
 * nav_tgc_11091_user_nav_left_menu.tsx
 *
 * USER NAV LEFT MENU Pattern - Left Overlay Menu with Parent-Child Modules
 *
 * Visual style: Drawer-based left sidebar with floor-grouped accordion sections.
 * Data source: Component_Registry2 @Manage=12 (IncludeIn_UserNav=1) via /api/cr2-registry
 * Displays parent modules organized by floor (same data as Test User Nav grid).
 *
 * Created: 2026-07-16
 * Pattern: Parent-Child Navigation (API-driven, not directory manifest)
 */
import React from 'react';
import { getTsxFileName } from '../../utils/componentIdentity';
import { DirmLeftMenuParentChildPattern } from '../ComponentTemplates/DirectoryPatterns';

const Self = () => <DirmLeftMenuParentChildPattern seq={11091} />;
Self.displayName = getTsxFileName(import.meta.url);

export default Self;
